<template>
  <section class="get-today-list">
    <p class="get-today-list__text">
      {{ messages.reserveInfo }}
    </p>
    <div class="get-today-list-row">
      <DefSelectWrapper :value="activeCityName || activeStoreCityName">
        <template #header>
          <span>{{ activeCityName || activeStoreCityName }}</span>
        </template>
        <template #placeholder>
          <span>
            {{ messages.stores.city }}
          </span>
        </template>
        <div
          v-for="item in cities.filter((el) => !el.active)"
          :key="item.ID"
          @click="changeCurrentCityId(item.ID)"
        >
          {{ item.UF_NAME }}
        </div>
      </DefSelectWrapper>
      <GetTodayListTabs
        :active-tab="activeTab"
        :messages="messages?.stores"
        @changeActiveTab="activeTab = $event"
      />
    </div>

    <div v-if="activeTab == 1" class="get-today-list-items">
      <GetTodayListStore
        v-for="store in getStoresFilteredByCityAndAmount"
        :result="store"
        :messages="messages"
        @reserve="$emit('reserve', $event)"
      />
    </div>
    <DefMap v-else-if="activeTab == 2" :key="currentCityId" @handlerSelectShop="selectStoreFromMap">
      <div
        v-for="store in getStoresFilteredByCityAndAmount"
        :lat="store.gpsN"
        :lng="store.gpsS"
        class="def-map-popup"
      >
        <h6 class="def-map-popup__title">{{ store.address }}</h6>
        <p class="def-map-popup__text">
          <svg class="def-map-popup__text__icon">
            <use xlink:href="#svg-clock-arrow"></use>
          </svg>
          {{ store.schedule }}
        </p>
        <p class="def-map-popup__text">
          <svg class="get-today-list-store__icon">
            <use xlink:href="#svg-phone"></use>
          </svg>
          {{ store.phone }}
        </p>
        <button type="button" class="def-map-popup__button">Обрати</button>
      </div>
    </DefMap>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';
import GetTodayListTabs from '@components/Product/GetToday/GetTodayListTabs.vue';
import GetTodayListStore from '@components/Product/GetToday/GetTodayListStore.vue';
import DefMap from '@components/Def/DefMap/DefMap.vue';

export default {
  /**
   * @todo ПЕРЕДЕЛАТЬ на VueX! На бекенде данные записывать в стору, на фронте использовать стору Stores (склады) вместо механики ниже.
   */
  name: 'GetTodayList',
  components: { DefMap, GetTodayListStore, GetTodayListTabs, DefSelectWrapper },
  props: ['result', 'messages'],
  data() {
    return {
      activeTab: 1,
    };
  },
  computed: {
    ...mapGetters({
      cityId: 'cities/id',
      activeCityName: 'stores/getActiveCityName',
      cities: 'stores/getCities',
      storesFilteredByCity: 'stores/getStoresFilteredByCity',
      getStoresFilteredByCityAndAmount: 'stores/getStoresFilteredByCityAndAmount',
      currentCityId: 'stores/getCurrentCityId',
    }),
    activeStoreCityName() {
      return this.getStoresFilteredByCityAndAmount?.[0]?.cityName;
    },
  },
  methods: {
    ...mapMutations({
      changeCurrentCityId: 'stores/changeCurrentCityId',
    }),
    /**
     * @todo @dimapavliuk
     * @param lat
     * @param lng
     */
    selectStoreFromMap({ lat, lng }) {
      const selectedStore = this.getStoresFilteredByCityAndAmount.find((el) => {
        if (el.gpsN === lat && el.gpsS === lng) {
          return true;
        }
        return false;
      });
      if (selectedStore) {
        this.$emit('reserve', selectedStore);
      } else {
        console.error('problem with selected store');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.get-today-list {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  &__text {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    margin-bottom: 12px;
    @include point-md {
      margin-bottom: 24px;
    }
  }

  :deep(.def-select-wrapper) {
    @include point-md {
      max-width: 312px;
    }
    @include point-lg {
      max-width: 388px;
    }
  }

  :deep(.def-map) {
    flex-grow: 1;
    min-height: 292px;
    @include point-md {
      min-height: 744px;
    }
    @include point-lg {
      min-height: 606px;
    }
  }
}
.get-today-list-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
  @include point-md {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 24px;
  }
}
.get-today-list-items {
  display: grid;
  grid-row-gap: 16px;
}
</style>
